import {get, post, put, destroy} from './config';

const Aviation = {
    getAirports: (countryId) =>
        get(`/v1/directories/airports/by-${countryId}`),
    createOrder: (data) =>
        post('/v1/airorders/create', data),
    update: (orderId, data) =>
      put(`/v1/airorders/update/${orderId}`, data),
    getOrderListForExpeditor: (params) =>
        post(`v1/airorders/expeditor/list`, params),
    getStatusWithOrderCountsForExpeditor: (data) =>
        post(`/v1/airorders/expeditor/count`, data),
    getAirOrdersById: (orderId, lang) =>
        get(`/v1/airorders/by-${orderId}?lang=${lang}`),
    getOwnAirOrders: (params ) =>
        post('/v1/airorders/own/list', params ),
    getOwnAirOrderQuantity: (data) =>
        post(`/v1/airorders/own/count`, data),
    getListSuggestedPriceAir: (orderId) =>
        get(`/v1/airorderbids/list?orderId=${orderId}`),
    getSuggestedPriceByExpeditor: (orderId) => 
        get(`/v1/airorderbids/by-expeditor?orderId=${orderId}`), 
    getExtraCostsByOrderId: (orderId) =>
        get(`/v1/airorderbids/extra-costs?orderId=${orderId}`),
    updateSuggestedPrice: (id, data) =>
        put(`/v1/airorderbids/${id}`, data),
    deleteSuggestedPrice: (id) =>
        destroy(`/v1/airorderbids/${id}`),
    acceptAirTender: (id) =>
        post(`v1/airorderbids/accept/${id}`),
    acceptExtraCost: (id) =>
        post(`/v1/airorderbids/extra-costs/accept/${id}`),
    rejectExtraCost: (id) =>
        post(`/v1/airorderbids/extra-costs/reject/${id}`),
    suggestedPrice: (orderId, data) =>
        post(`v1/airorderbids/${orderId}`, data),
    updateAirTenderPrice: (orderId, data) =>
        post(`/v1/airorderbids/new-price/${orderId}`, data),
    decideAirTenderNewPrice: (status, id) =>
        post(`/v1/airorderbids/new-price/${id}/${status}`),
    updateStatus: (id, status) =>
        post(`v1/airorders/expeditor/update-status/${id}/${status}`),
    rejectTender: (orderId) =>
        put(`/v1/airorders/expeditor/reject-tender/${orderId}`),
    reassignExpeditor: (orderId, data) =>
        post(`/v1/airorders/${orderId}/reassign-expeditor`, data),
    updateClientStatus: (id, status, comment = '') =>
        post(`v1/airorders/update-status/${id}/${status}`, { comment }),
    getHistory: (orderId) => 
        get(`v1/airorders/${orderId}/states`),
    getOrderChat: (orderId) =>
        get(`airorderchats/${orderId}`),
    sendMessage: (data) =>
        post(`airorderchats`, data),
    readOrderChat: (id) =>
        put(`/airorderchats/read/${id}`),
    getUnreadMessages: (orderId) =>
        get(`/airorderchats/unread/${orderId}`),
    canceled: (data) =>
        post('/v1/airorders/canceled', data),
    deleteOrder: (orderId,user,reason) =>
        destroy(`v1/airorders/${orderId}?username=${user}&reason=${reason}`),
    getClientExportAirOrders: (data = {}) => 
        post('/v1/export/air-orders/client', data, { responseType: 'blob'}),
    extendTenderDateEnd: (id, tenderDateEnd) =>
        put(`/v1/airorders/extend-tender-date-end/${id}?tenderDateEnd=${tenderDateEnd}`),
    rebidTender: (orderId, tenderDateEnd) =>
        put(`/v1/airorders/rebid/${orderId}?tenderDateEnd=${encodeURIComponent(tenderDateEnd)}`),
    sendToMarketplace: (orderId, tenderDateEnd) =>
        post(`/v1/airorders/send-marketplace/${orderId}?tenderDateEnd=${tenderDateEnd}`),
    getPartnersByAirOrder: (orderId) =>
        get(`/v1/airorders/partners/by-order-${orderId}`),
    updateReferenceNumber: (orderId, referenceNumber) =>
        put(`/v1/airorders/reference-number/${orderId}`, { referenceNumber }),
    updateDimensionalWeight: (orderId, dimensionalWeight) =>
        put(`/v1/airorders/dimensional-weight/${orderId}`, { dimensionalWeight }),
    updateExpectedUnloadingDate: (orderId, data) =>
        put(`/v1/airorders/expected-unloading-date/${orderId}`, data),
    updateShippingDate: (orderId, data) =>
        put(`/v1/airorders/update/shipping-date/${orderId}`, data),
}

export default Aviation;
